import React from 'react';
import PropTypes from 'prop-types';

import List from 'react-toolbox/lib/list/List';
import ListItem from 'react-toolbox/lib/list/ListItem';
import Button from 'react-toolbox/lib/button/Button';
import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar';

import Listing from "../containers/Listing";
import Registration from "../containers/Registration";

import styled from 'styled-components';
import {FormRow, Picture, Striped, ThemedHeader, TwoColumnRow} from '../../Styled';

import topPicture from '../../../images/tours/colombia-top.jpg';
import sidePicture from '../../../images/tours/colombia-side.jpg';

const StyledList = styled(List)`
    white-space: normal;
`;

const Tours = ({loadWaiting, loadSuccess, isFilled, submit, submitWaiting, submitSuccess, submitFailure}) => {
    return (
        <React.Fragment>
            <Striped>
                <TwoColumnRow>
                        <span>
                        <ThemedHeader>Colombia 2021!</ThemedHeader>
                            <p>We create paradise on earth! Don't believe it? Come join us for an all included tour to one of the easiest and most scenic places to paraglide! We encourage people to bring their non-flying partners as well - there are plenty of fun things to do even without flying!</p>
                        </span>
                    <Picture src={topPicture}/>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <TwoColumnRow>
                    <Picture className='mobile-row-2' src={sidePicture}/>
                    <div className='mobile-row-1'>
                        <ThemedHeader>Includes</ThemedHeader>
                        <StyledList>
                            <ListItem leftIcon='flight'
                                      caption='Airport transportation'
                                      legend='Pick up and drop off at the airport'
                                      ripple={false}/>
                            <ListItem leftIcon='restaurant'
                                      caption='Breakfast'
                                      legend='Every morning at the hotel'
                                      ripple={false}/>
                            <ListItem leftIcon='directions_bus'
                                      caption='Rides to launch'
                                      legend='Whichever launch is working that day'
                                      ripple={false}/>
                            <ListItem leftIcon='account_balance'
                                      caption='Weather & Thermal course'
                                      legend='Local topics as well as worldwide'
                                      ripple={false}/>
                            <ListItem leftIcon='wifi'
                                      caption='In-air coaching'
                                      legend='During your entire flight'
                                      ripple={false}/>
                            <ListItem leftIcon='local_see'
                                      caption='Cloudbase'
                                      legend='Take pictures of you surfing the clouds'
                                      ripple={false}/>
                            <ListItem leftIcon='directions_bus'
                                      caption='Retrieve'
                                      legend="We'll come get you!"
                                      ripple={false}/>
                        </StyledList>
                    </div>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <FormRow>
                    <ThemedHeader>Registration</ThemedHeader>
                    <span style={{minWidth: "100%"}}>
                        {loadWaiting && <ProgressBar type="linear" mode="indeterminate"/>}

                        {loadSuccess && <Listing/>}

                        <Registration/>

                        {!submitWaiting && !submitSuccess && !submitFailure &&
                         <Button icon='payment' label='Pay deposit with card' raised primary
                                 disabled={!isFilled} onClick={submit}/>}

                        {submitWaiting &&
                         <ProgressBar type="circular" mode="indeterminate"/>}

                        {submitSuccess &&
                         <div style={{color: 'green'}}>
                             <strong>Your card has been charged. Thank you!</strong>
                         </div>}

                        {submitFailure &&
                         <div style={{color: 'red'}}>
                             <strong>Something went wrong! Please let us know and try again later.</strong>
                         </div>}
                    </span>
                </FormRow>
            </Striped>
        </React.Fragment>
    )
};

Tours.propTypes = {
    isFilled:      PropTypes.bool.isRequired,
    submit:        PropTypes.func.isRequired,
    submitWaiting: PropTypes.bool.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    submitFailure: PropTypes.bool.isRequired
};

export default Tours;



// WEBPACK FOOTER //
// ./src/app/tours/components/Tours.js